<!--
하나의 활동내역을 표시,
활동내역의 type 별로 표현방법을 분기함
-->
<template>
    <div class="">

        <!-- 댓글 -->
        <div v-if="typeText === 'COMMENT'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <span class="uk-text-meta" v-if="activity.updated_at !== activity.created_at">(edited)</span>
            <div class="uk-margin-left">
                <div
                        v-show="!commentEditMode"
                        class="uk-inline uk-background-default uk-padding-small uk-box-shadow-medium uk-border-rounded"

                >
                    <p class="" v-html="commentBr"></p>
                </div>

                <!-- 수정 폼 -->
                <div v-show="commentEditMode" class="">
                    <app-input-ex
                            type="textarea"
                            name="comment"
                            v-model="activity.comment"
                            :textarea-rows="8"
                            placeholder="Write a comment.."
                    ></app-input-ex>
                    <button
                            class="uk-button uk-button-primary uk-width-1-1"
                            v-on:click="updateComment"

                    >
                        <span uk-icon="icon: check"></span> SAVE
                    </button>
                </div>
            </div>

            <!-- 수정버튼 -->
            <div class="uk-margin-left" v-show="commentEditable">
                <a class="uk-link-reset" v-show="!commentEditMode" v-on:click="commentEditMode=true">edit</a>
                <a class="uk-link-reset" v-show="commentEditMode" v-on:click="commentEditMode=false">cancel</a>
            </div>



        </div>

        <!-- 할당 -->
        <div v-if="typeText === 'ALLOCATE'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                
                '{{ allocateToText(p1Json.allocate_to) }}' 으로 할당되었습니다
            </div>

        </div>

        <!-- ADD_FILE -->
        <div v-if="typeText === 'ADD_FILE'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                {{ activity.p2 }} added ...
            </div>

        </div>

        <!-- REMOVE_FILE -->
        <div v-if="typeText === 'REMOVE_FILE'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                {{ activity.p2 }} removed ...
            </div>

        </div>

        <!-- 창고문의등록 -->
        <div v-if="typeText === 'WORK_REQ_CREATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                This article has been created ...
            </div>

        </div>


        <!-- WORK_REQ_UPDATED -->
        <div v-if="typeText === 'WORK_REQ_UPDATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                TITLE or CONTENT has been modified ...
            </div>

        </div>

        <!-- WORK_REQ_STATE_CHANGED -->
        <div v-if="typeText === 'WORK_REQ_STATE_CHANGED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                STATE has been changed ...
            </div>
        </div>


        <!-- 반품신청서 작성 -->
        <div v-if="typeText === 'RETURN_CREATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                반품신청서가 작성되었습니다
            </div>
        </div>

        <!-- 반품정보 수정 -->
        <div v-if="typeText === 'RETURN_UPDATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                [정보수정]
                <div
                    v-for="(val, name) in p1Json"
                    :key="name"
                >
                    {{ name }} : {{ val }}
                </div>
            </div>
        </div>

        <!-- 반품상태변경 -->
        <div v-if="typeText === 'RETURN_STATE_CHANGED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                반품단계가 '{{ returnStateText(activity.p1) }}' 으로 변경되었습니다
            </div>
        </div>


        <!-- 오류설정 -->
        <div v-if="typeText === 'ERROR_CREATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                오류설정 되었습니다
            </div>
        </div>

        <div v-if="typeText === 'ERROR_UPDATED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                [정보수정]
                <div
                    v-for="(val, name) in p1Json"
                    :key="name"
                >
                    {{ name }} : {{ val }}
                </div>
            </div>
        </div>

        <!-- 오류해지 -->
        <div v-if="typeText === 'ERROR_FINISHED'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                오류해지 되었습니다
            </div>
        </div>

        

        <!-- 기타 -->
        <div v-if="typeText === 'ETC'">
            <i class="material-icons uk-text-middle">
                account_circle
            </i>
            <span class="uk-text-bold">{{ activity.updated_by }}</span>
            <span class="uk-text-meta">at {{ activity.updated_at }}</span>
            <div class="uk-margin-left">
                activity type : {{ activity.type }} ...
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        props: {
            activity: {
                type: Object,
                default: null
            },
            /**
             * 댓글수정가능 여부
             */
            commentEditable: {
                type: Boolean,
                default: false
            },
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },

        },
        data: function () {
            return {
                /**
                 * 댓글수정모드
                 */
                commentEditMode: false
            };
        },
        computed: {
            /**
             * 활동내역 type을 텍스트로 구분해준다.
             * php 에 선언되어있는 코드표의 상수명과 동일하게 정의한다.
             * @returns {string}
             */
            typeText: function () {
                if (this.activity.type === 1) {
                    return 'COMMENT';
                } else if (this.activity.type === 11) {
                    return 'ALLOCATE';
                } else if (this.activity.type === 12) {
                    return 'ADD_FILE';
                } else if (this.activity.type === 13) {
                    return 'REMOVE_FILE';
                } else if (this.activity.type === 61) {
                    return 'WORK_REQ_CREATED';
                } else if (this.activity.type === 62) {
                    return 'WORK_REQ_UPDATED';
                } else if (this.activity.type === 63) {
                    return 'WORK_REQ_STATE_CHANGED';
                } else if (this.activity.type === 71) {
                    return 'RETURN_CREATED';
                } else if (this.activity.type === 72) {
                    return 'RETURN_UPDATED';
                } else if (this.activity.type === 73) {
                    return 'RETURN_STATE_CHANGED';
                } else if (this.activity.type === 81) {
                    return 'ERROR_CREATED';
                } else if (this.activity.type === 82) {
                    return 'ERROR_UPDATED';
                } else if (this.activity.type === 83) {
                    return 'ERROR_FINISHED';
                } else {
                    return 'ETC';
                }
            },
            /**
             * 활동내역의 p1을 json 디코딩
             */
            p1Json: function () {
                return JSON.parse(this.activity.p1);
            },
            /**
             * 활동내역의 p2을 json 디코딩
             */
            p2Json: function () {
                return JSON.parse(this.activity.p2);
            },
            /**
             * br 태그 적용된 comment
             * @returns {string}
             */
            commentBr: function () {
                return this.activity.comment.replace(/(?:\r\n|\r|\n)/g, '<br />');
            },
        },
        watch: {
        },
        methods: {
            /**
             * 댓글수정
             */
            updateComment: function () {
                let cmp = this;
                let opts = {
                    type: 'patch',
                    url: '/communication-activities/'+this.activity.id+'/comment',
                    data: {
                        '_token': this.csrfToken,
                        //'_method': 'PATCH',
                        'comment': this.activity.comment
                    },
                    success: function () {
                        cmp.commentEditMode = false;
                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);

            },

            /**
             * allocate_To
             */
            allocateToText: function (code) {
                if (code == 1) {
                    return '한국총괄';
                } else if (code == 2) {
                    return '창고';
                } else if (code == 3) {
                    return '사용자';
                } else if (code == 9) {
                    return 'EMPTY';
                } else {
                    return code;
                }

            },

            /**
             * 반품단계
             */
            returnStateText: function (code) {
                if (code == 101) {
                    return '한국반품신청';
                } else if (code == 102) {
                    return '한국사무실로 발송';
                } else if (code == 103) {
                    return '한국사무실 수령';
                } else if (code == 104) {
                    return 'EMS 발송대기';
                } else if (code == 105) {
                    return 'EMS 발송완료';
                } else if (code == 106) {
                    return 'EMS 창고도착';
                } else if (code == 110) {
                    return '반품신청';
                } else if (code == 111) {
                    return '반품작업대기';
                } else if (code == 114) {
                    return '반품완료';
                } else if (code == 115) {
                    return '반품정보부족';
                } else if (code == 119) {
                    return '반품취소';
                } else {
                    return code;
                }

            },

        }
    }
</script>

<style lang="scss" scoped>

</style>